export default "__VITE_ASSET__BvrZ$HCJ__"